import { BaseWebComponentRepository } from '../../../framework/BaseWebComponentRepository';
import { TerminalDataProviderFactory } from '../factory/TerminalDataProviderFactory';
import { TerminalBaseDataProvider } from '../dataProvider/TerminalBaseDataProvider';
import { TerminalWebComponentSchema } from '../types';

export class TerminalRepository extends BaseWebComponentRepository {
  public dataProviderFactory: TerminalDataProviderFactory;
  public dataProvider: TerminalBaseDataProvider;

  constructor() {
    super();
    this.initialSetup({
      dataProviderFactory: new TerminalDataProviderFactory(),
    });
  }

  async getDataForView(): Promise<TerminalWebComponentSchema> {
    return this.dataProvider.getDataForView();
  }

  async checkFileExists(file): Promise<boolean> {
    return this.dataProvider.checkFileExists(file);
  }

  async getAuthenticationSettings(companyId): Promise<any> {
    return this.dataProvider.getAuthenticationSettings(companyId);
  }

  async isIdpRequestAuthorized(endpointId): Promise<any> {
    return this.dataProvider.isIdpRequestAuthorized(endpointId);
  }
}
